import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import { settingsStore } from "store/settingsStore";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";

const cacheRtl = createCache({
  key: "rtl",
  prepend: true,
  stylisPlugins: [prefixer, rtlPlugin],
});

const RTLProvider = ({ children }) => {
  const direction = settingsStore((state) => state.direction);

  if (direction === "ltr") {
    return <CacheProvider value={cacheRtl}>{children}</CacheProvider>;
  }

  return <>{children}</>;
};

export default RTLProvider;
